<template>
  <div
    class="el-step"
    :style="style"
    style="padding: 8px 0;"
    :class="[
      !isSimple && `is-${$parent.direction}`,
      isSimple && 'is-simple',
      isCenter && !isVertical && !isSimple && 'is-center',
      'is-' + currentStatus
     ]">
    <!-- icon & line -->
    <div
      class="el-step__head"
      :class="`is-${currentStatus}`">
      <div
        class="el-step__line"
        :style="isLast ? '' : { marginRight: $parent.stepOffset + 'px' }"
      >
        <i class="el-step__line-inner" :style="lineStyle"></i>
      </div>
    </div>
    <!-- title & description -->
    <div class="el-step__main">
      <div
        class="el-step__title"
        ref="title"
        :class="['is-' + currentStatus]"
        style="color: white;">
        <slot name="title">{{ title }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step',

  props: {
    title: String,
    icon: String,
    description: String,
    status: String,
  },

  data() {
    return {
      index: -1,
      lineStyle: {},
      internalStatus: '',
    };
  },

  beforeCreate() {
    this.$parent.steps.push(this);
  },

  beforeDestroy() {
    const { steps } = this.$parent;
    const index = steps.indexOf(this);
    if (index >= 0) {
      steps.splice(index, 1);
    }
  },

  computed: {
    currentStatus() {
      return this.status || this.internalStatus;
    },
    prevStatus() {
      const prevStep = this.$parent.steps[this.index - 1];
      return prevStep ? prevStep.currentStatus : 'wait';
    },
    isCenter() {
      return this.$parent.alignCenter;
    },
    isVertical() {
      return this.$parent.direction === 'vertical';
    },
    isSimple() {
      return this.$parent.simple;
    },
    isLast() {
      const parent = this.$parent;
      return parent.steps[parent.steps.length - 1] === this;
    },
    stepsCount() {
      return this.$parent.steps.length;
    },
    space() {
      const { isSimple, $parent: { space } } = this;
      return isSimple ? '' : space;
    },
    style() {
      const style = {};
      const parent = this.$parent;
      const len = parent.steps.length;

      const space = (typeof this.space === 'number'
        ? `${this.space}px`
        : this.space
          ? this.space
          : `${100 / (len - (this.isCenter ? 0 : 1))}%`);
      style.flexBasis = space;
      if (this.isVertical) return style;
      if (this.isLast) {
        style.maxWidth = `${100 / this.stepsCount}%`;
      } else {
        style.marginRight = `${-this.$parent.stepOffset}px`;
      }

      return style;
    },
  },

  methods: {
    updateStatus(val) {
      const prevChild = this.$parent.$children[this.index - 1];

      if (val > this.index) {
        this.internalStatus = this.$parent.finishStatus;
      } else if (val === this.index && this.prevStatus !== 'error') {
        this.internalStatus = this.$parent.processStatus;
      } else {
        this.internalStatus = 'wait';
      }

      if (prevChild) prevChild.calcProgress(this.internalStatus);
    },

    calcProgress(status) {
      let step = 100;
      const style = {};

      style.transitionDelay = `${150 * this.index}ms`;
      if (status === this.$parent.processStatus) {
        step = this.currentStatus !== 'error' ? 0 : 0;
      } else if (status === 'wait') {
        step = 0;
        style.transitionDelay = `${-150 * this.index}ms`;
      }

      style.borderWidth = step && !this.isSimple ? '1px' : 0;
      this.$parent.direction === 'vertical'
        ? style.height = `${step}%`
        : style.width = `${step}%`;

      this.lineStyle = style;
    },
  },

  mounted() {
    const unwatch = this.$watch('index', (val) => {
      this.$watch('$parent.active', this.updateStatus, { immediate: true });
      this.$watch('$parent.processStatus', () => {
        const activeIndex = this.$parent.active;
        this.updateStatus(activeIndex);
      }, { immediate: true });
      unwatch();
    });
  },
};
</script>
<style lang="scss">
  .el-step.is-simple.is-process {
    background: #169BD5 !important;
  }
  .el-step.is-simple.is-finish {
    background: #169BD5 !important;
  }
  .el-step.is-simple .el-step__main {
    justify-content: center !important;
  }
  .el-step.is-simple.is-process:before{
    content: "";
    width: 50px;
    height: 100%;
    background: url("../../assets/blueFillArrow.svg") no-repeat;
    position: absolute;
    right: -50px;
    z-index: 1;
  }
  .el-step.is-simple.is-wait:before {
    content: "";
    width: 30px;
    height: 100%;
    background: url("../../assets/whiteFillArrow.svg") no-repeat;
    position: absolute;
    right: -30px;
    &:last-child {
      background: none;
    }
  }
  .el-step.is-simple.is-finish:before {
    content: "";
    width: 50px;
    height: 100%;
    background: url("../../assets/blueFillArrow.svg") no-repeat;
    position: absolute;
    right: -50px;
    z-index: 1;
  }
  .el-step:last-child:before {
    display: none;
  }
</style>
